module.exports = "/assets/data/f7d0299a449ec59166b7158e7cc4e61b-SA66.data.json";